import { render, staticRenderFns } from "./SearchBanner.vue?vue&type=template&id=35ab8001&scoped=true&"
import script from "./SearchBanner.vue?vue&type=script&lang=js&"
export * from "./SearchBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ab8001",
  null
  
)

export default component.exports